import Vue from "vue";
import {Component, Prop, Watch} from "vue-property-decorator";
import {LanguageManager} from "../../../languages/languages";
import "./epromStatus.styl";
import {type} from "os";
const template = require("./epromStatus.vue");

@Component({
  template: template
})
export default class EpromStatusComponent extends Vue {

  statusMessage: any = null;

  labels: any = [
    { title: "Test", subtitle: "Test subtitle" },
    { divider: true, inset: true },
    { title: "Test2" },
    { divider: true, inset: true },
    { title: "Test3", subtitle: "Test subtitle3" }
  ];
  
  @Prop()
  type: string;
  @Prop()
  response: any;

  created() {
    console.log("type", this.type);
    this.checkTypeVar();
    this.checkResponse();
  }

  @Watch("type")
    checkTypeVar() {
      if (this.type === "status") {

        if (this.response.first_engine_vel_int <= 2 && this.response.second_engine_vel_int <= 2) {
          this.statusMessage = LanguageManager.instance.i18n.t("automation_status_stopped");

          if (this.response.single_engine) {
            if (this.response.second_engine_pos_int <= 10) {
              this.statusMessage = LanguageManager.instance.i18n.t("automation_status_closed");
            } else if (this.response.second_engine_pos_int >= 90) {
              this.statusMessage = LanguageManager.instance.i18n.t("automation_status_opened");
            }
          } else {
            if (this.response.first_engine_pos_int <= 10 && this.response.second_engine_pos_int <= 10) {
              this.statusMessage = LanguageManager.instance.i18n.t("automation_status_closed");
            } else if (this.response.first_engine_pos_int >= 90 && this.response.second_engine_pos_int >= 90) {
              this.statusMessage = LanguageManager.instance.i18n.t("automation_status_opened");
            }
          }
        } else {
          this.statusMessage = LanguageManager.instance.i18n.t("automation_status_moving");
        }
      }
    }
  @Watch("response")
    checkResponse() {
      if (this.type === "status") {

        if (this.response.first_engine_vel_int <= 2 && this.response.second_engine_vel_int <= 2) {
          this.statusMessage = LanguageManager.instance.i18n.t("automation_status_stopped");

          if (this.response.single_engine) {
            if (this.response.second_engine_pos_int <= 10) {
              this.statusMessage = LanguageManager.instance.i18n.t("automation_status_closed");
            } else if (this.response.second_engine_pos_int >= 90) {
              this.statusMessage = LanguageManager.instance.i18n.t("automation_status_opened");
            }
          } else {
            if (this.response.first_engine_pos_int <= 10 && this.response.second_engine_pos_int <= 10) {
              this.statusMessage = LanguageManager.instance.i18n.t("automation_status_closed");
            } else if (this.response.first_engine_pos_int >= 90 && this.response.second_engine_pos_int >= 90) {
              this.statusMessage = LanguageManager.instance.i18n.t("automation_status_opened");
            }
          }
        } else {
          this.statusMessage = LanguageManager.instance.i18n.t("automation_status_moving");
        }
      }
    }
}

Vue.component("cmEpromStatus", EpromStatusComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/plain/epromStatus/epromStatus.ts